/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_First_TitleInputs */



/**
* | output |
* | --- |
* | "First event" |
*
* @param {Image_Export_Preview_First_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_first_title = /** @type {((inputs?: Image_Export_Preview_First_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_First_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Premier evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erste Veranstaltung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Primo evento")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Первое событие")
	if (locale === "es") return /** @type {LocalizedString} */ ("Primer evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("首场活动")
	if (locale === "ja") return /** @type {LocalizedString} */ ("最初のイベント")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पहला आयोजन")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Primeiro evento")
	return /** @type {LocalizedString} */ ("First event")
});